import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { ShiftOptions } from "@/features/shift/model/Shift/Shift";
import { useQuery } from "@tanstack/react-query";

import { MeasurementsDaily } from "@/model/Application/Settings/SettingsResponseTypes";

export const useFetchMeasurementsDaily = () => {
	return useQuery<MeasurementsDaily[]>({
		queryKey: [LabQueryKeys.labDaily, LabQueryKeys.original],
		queryFn: () => SATOSPortal.GetMeasurementsDaily(),
	});
};

export const useFetchMeasurementsDailySaveClear = () => {
	return useQuery<MeasurementsDaily[]>({
		queryKey: [LabQueryKeys.labDaily, LabQueryKeys.saveClear],
		queryFn: () => SATOSPortal.GetMeasurementsDailySaveClear(),
	});
};

export const useFetchMeasurementsSpot = () => {
	return useQuery<MeasurementsDaily[]>({
		queryKey: [LabQueryKeys.spotSample, LabQueryKeys.labDaily],
		queryFn: () => SATOSPortal.GetMeasurementsSpot(),
	});
};

export const useFetchMeasurementById = (id: number | null) => {
	return useQuery<unknown>({
		queryKey: [LabQueryKeys.labDaily, id],
		queryFn: () => SATOSPortal.GetMeasurementById({ id }),
		enabled: !!id,
	});
};

export const useFetchMeasurementAnalyzeById = (id: number | null) => {
	return useQuery<unknown>({
		queryKey: [LabQueryKeys.labDaily, id],
		queryFn: () => SATOSPortal.GetMeasurementAnalyzeById({ id }),
		enabled: !!id,
	});
};

export const useFetchMeasurementDaily = () => {
	return useQuery<MeasurementsDaily[]>({
		queryKey: [LabQueryKeys.labDaily],
		queryFn: () => SATOSPortal.GetMeasurementsDaily(),
	});
};
export const useFetchGroupId = (id: number | null) => {
	return useQuery<unknown>({
		queryKey: [LabQueryKeys.labDaily, LabQueryKeys.labGroups, id],
		queryFn: () => SATOSPortal.GetMeasurementByGroupId({ id }),
		enabled: !!id,
	});
};

export const useFetchLabAnalyzeList = (id: number | null) => {
	return useQuery<unknown>({
		queryKey: [LabQueryKeys.labDaily, id],
		queryFn: () => SATOSPortal.GetLabAnalyzeListById({ id }),
		enabled: !!id,
	});
};

export const useFetchLabAnalyzeById = (id: number | null) => {
	return useQuery<unknown>({
		queryKey: [LabQueryKeys.labDaily, id],
		queryFn: () => SATOSPortal.GetLabAnalyzeById({ id }),
		enabled: !!id,
	});
};
export const useFetchLabGroups = () => {
	return useQuery<unknown[]>({
		queryKey: [LabQueryKeys.labDaily],
		queryFn: () => SATOSPortal.GetLabGroups(),
	});
};

export const useFetchLabSystems = () => {
	return useQuery<unknown[]>({
		queryKey: [LabQueryKeys.labDaily, LabQueryKeys.labEdit],
		queryFn: () => SATOSPortal.GetLabSystems(),
	});
};

export const useFetchLabGroupsMeasurementPage = (id: number | null) => {
	return useQuery<unknown>({
		queryKey: [LabQueryKeys.labGroups, id],
		queryFn: () => SATOSPortal.GetFetchLabGroupsMeasurementPage({ id }),
		enabled: !!id,
	});
};

export const useFetchLabReportPageId = (id: number) => {
	return useQuery<unknown>({
		queryKey: [LabQueryKeys.labDaily, id],
		queryFn: () => SATOSPortal.GetLabReportPageId({ id }),
		enabled: id !== null,
	});
};

export const useFetchLabParams = () => {
	return useQuery<unknown[]>({
		queryKey: [LabQueryKeys.spotSample],
		queryFn: () => SATOSPortal.GetLabParams(),
	});
};

export const useFetchLabParamsSearch = () => {
	return useQuery<unknown[]>({
		queryKey: [LabQueryKeys.labSearch],
		queryFn: () => SATOSPortal.GetLabParams(),
	});
};

export const useFetchLabReportPage = () => {
	return useQuery<unknown[]>({
		queryKey: [LabQueryKeys.labDaily],
		queryFn: () => SATOSPortal.GetLabReportPage(),
	});
};

export class LabQueryKeys {
	static readonly labDaily = "Lab Daily";
	static readonly spotSample = "Spot Sample";
	static readonly lastSpotSample = "Last Spot Sample";
	static readonly labSearch = "Lab Search";
	static readonly labReport = "Lab Report";
	static readonly labEdit = "Lab Edit";
	static readonly labGroups = "Lab Groups";
	static readonly original = "original";
	static readonly saveClear = "save-clear";
}

export interface FetchShiftOptionsResult {
	data: ShiftOptions | undefined;
	isLoading: boolean;
}
